// assets/ssc-product.js
(function () {
  /* ── GALERIE ── */
  const gallery = document.querySelector('[data-product-gallery]');
  if (gallery) {
    const slides = gallery.querySelectorAll('.ssc-pdp-gallery__slide');
    const dots = gallery.querySelectorAll('.ssc-pdp-gallery__dot');
    const inner = gallery.querySelector('.ssc-pdp-gallery__inner');
    let current = 0;

    function goTo(idx, animate) {
      if (!slides.length) return;
      slides[current].classList.remove('is-active');
      dots[current]?.classList.remove('is-active');
      current = (idx + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      dots[current]?.classList.add('is-active');
      if (inner) {
        if (animate === false) {
          inner.style.transition = 'none';
        } else {
          inner.style.transition = '';
        }
        inner.style.transform = 'translateX(-' + (current * 100) + '%)';
      }
    }
    gallery.__sscGoTo = goTo;
    gallery.__sscSlides = slides;

    const prevArrow = gallery.querySelector('.ssc-pdp-gallery__arrow--prev');
    const nextArrow = gallery.querySelector('.ssc-pdp-gallery__arrow--next');

    if (prevArrow) prevArrow.addEventListener('click', () => goTo(current - 1));
    if (nextArrow) nextArrow.addEventListener('click', () => goTo(current + 1));

    dots.forEach(dot => {
      dot.addEventListener('click', () => goTo(parseInt(dot.dataset.index, 10)));
    });

    /* ── SWIPE / TOUCH smooth ── */
    const mainEl = gallery.querySelector('#ssc-gallery-main');
    if (mainEl && inner) {
      let touchStartX = 0;
      let touchStartY = 0;
      let dragging = false;

      mainEl.addEventListener('touchstart', function(e) {
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        dragging = false;
        inner.style.transition = 'none';
      }, { passive: true });

      mainEl.addEventListener('touchmove', function(e) {
        const dx = e.touches[0].clientX - touchStartX;
        const dy = e.touches[0].clientY - touchStartY;
        if (!dragging && Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 8) {
          dragging = true;
        }
        if (dragging) {
          const base = current * 100;
          const pct = (dx / mainEl.offsetWidth) * 100;
          inner.style.transform = 'translateX(calc(-' + base + '% + ' + dx + 'px))';
        }
      }, { passive: true });

      mainEl.addEventListener('touchend', function(e) {
        const dx = e.changedTouches[0].clientX - touchStartX;
        const dy = e.changedTouches[0].clientY - touchStartY;
        inner.style.transition = '';
        if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 50) {
          if (dx < 0) goTo(current + 1);
          else goTo(current - 1);
        } else {
          inner.style.transform = 'translateX(-' + (current * 100) + '%)';
        }
        dragging = false;
      }, { passive: true });
    }
  }

  /* ── WISHLIST ── */
  // No custom click override here (to avoid breaking native app behavior).
  // Initialize only SSC wishlist buttons, not native app product-page button.
  function initSscWishlistHeroButtons() {
    document
      .querySelectorAll(
        '.ssc-product-card__wish .wishlist-hero-custom-button'
      )
      .forEach(btn => {
        const e = new CustomEvent('wishlist-hero-add-to-custom-element', { detail: btn, bubbles: true });
        document.dispatchEvent(e);
      });
  }
  initSscWishlistHeroButtons();
  document.addEventListener('shopify:section:load', initSscWishlistHeroButtons);

  // Do not intercept Wishlist Hero product-page button clicks here.
  // Let the app handle its own desktop/main-product behavior natively.

  /* ── QUANTITÉ ── */
  document.querySelectorAll('[data-action]').forEach(btn => {
    if (btn.dataset.action === 'qty-minus' || btn.dataset.action === 'qty-plus') {
      btn.addEventListener('click', function () {
        const wrapper = this.closest('.ssc-pdp-qty__ctrl');
        if (!wrapper) return;
        const input = wrapper.querySelector('.ssc-pdp-qty__input');
        if (!input) return;

        let val = parseInt(input.value, 10) || 1;
        if (this.dataset.action === 'qty-plus') {
          input.value = val + 1;
        } else {
          input.value = Math.max(1, val - 1);
        }
      });
    }
  });

  /* ── PDP: OPTION PICKERS (COULEUR / TAILLE) ── */
  document.querySelectorAll('form[data-product-form]').forEach(form => {
    const container = form.closest('.ssc-product-info');
    const variantsScript = container?.querySelector('.ssc-product-variants-data');
    const captionsScript = container?.querySelector('.ssc-product-variant-captions');
    const optionGroups = form.querySelectorAll('.ssc-product-option[data-option-index]');
    const variantInput = form.querySelector('input[name="id"]');
    const priceRoot = form.querySelector('.ssc-product-price');
    const priceCurrent = form.querySelector('.ssc-product-price__current');
    const ctaButton = form.querySelector('.ssc-pdp-cta');
    const galleryCaption = document.querySelector('.ssc-pdp-gallery__caption');
    const defaultCaption = galleryCaption?.getAttribute('data-default-caption') || '';
    const moneyFormat = form.getAttribute('data-money-format') || '${{amount}}';
    const pdpGallery = document.querySelector('[data-product-gallery]');
    if (!variantsScript || !optionGroups.length || !variantInput) return;

    let variants = [];
    try {
      variants = JSON.parse(variantsScript.textContent || '[]');
    } catch (_) {
      variants = [];
    }
    let variantCaptions = {};
    if (captionsScript) {
      try {
        variantCaptions = JSON.parse(captionsScript.textContent || '{}');
      } catch (_) {
        variantCaptions = {};
      }
    }
    if (!variants.length) return;

    function setGroupSelection(group, button) {
      const isSwatchGroup = !!group.querySelector('.ssc-swatch');
      group.querySelectorAll('button[data-value]').forEach(btn => {
        const selected = btn === button;
        btn.classList.toggle('is-selected', selected);
        btn.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
      const selectedText = group.querySelector('[data-selected-value]');
      if (selectedText && button) {
        selectedText.textContent = ` — ${button.getAttribute('data-value') || ''}`;
      }
      if (isSwatchGroup && button) {
        button.classList.add('is-selected');
      }
    }

    function getSelectedOptions() {
      const optionCount = variants[0]?.options?.length || optionGroups.length;
      const options = Array(optionCount).fill('');
      optionGroups.forEach(group => {
        const idx = parseInt(group.getAttribute('data-option-index'), 10);
        const selected =
          group.querySelector('button[data-value].is-selected') ||
          group.querySelector('button[data-value]');
        if (!Number.isNaN(idx) && idx >= 0 && idx < optionCount && selected) {
          options[idx] = selected.getAttribute('data-value') || '';
        }
      });
      return options;
    }

    function formatMoney(cents) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, moneyFormat);
      }
      return `${(Number(cents || 0) / 100).toFixed(2)}€`;
    }

    function syncVariantUi(variant) {
      if (!variant) return;

      variantInput.value = String(variant.id);

      if (priceCurrent) {
        priceCurrent.textContent = formatMoney(variant.price);
      }

      if (priceRoot) {
        let compare = priceRoot.querySelector('.ssc-product-price__compare');
        if (variant.compare_at_price && Number(variant.compare_at_price) > Number(variant.price)) {
          if (!compare) {
            compare = document.createElement('span');
            compare.className = 'ssc-product-price__compare';
            priceRoot.insertBefore(compare, priceCurrent || priceRoot.firstChild);
          }
          compare.textContent = formatMoney(variant.compare_at_price);
          compare.style.display = '';
        } else if (compare) {
          compare.style.display = 'none';
        }
      }

      if (ctaButton) {
        const available = !!variant.available;
        ctaButton.disabled = !available;
        ctaButton.textContent = available ? 'AJOUTER AU PANIER' : 'ÉPUISÉ';
      }

      const pdpWish = form.closest('.ssc-product-info')?.parentElement?.querySelector('.ssc-pdp-gallery__wish');
      if (pdpWish) {
        pdpWish.setAttribute('data-wlh-variant-id', String(variant.id));
        pdpWish.setAttribute('data-wlh-variantid', String(variant.id));
        if (variant.url) {
          pdpWish.setAttribute('data-wlh-link', variant.url);
        }
      }

      if (galleryCaption) {
        const captionForVariant = variantCaptions[String(variant.id)];
        galleryCaption.textContent = captionForVariant || defaultCaption;
      }

      if (pdpGallery && pdpGallery.__sscGoTo && pdpGallery.__sscSlides && variant.featured_image?.id) {
        const slides = Array.from(pdpGallery.__sscSlides);
        const targetIdx = slides.findIndex(
          slide => String(slide.getAttribute('data-image-id')) === String(variant.featured_image.id)
        );
        if (targetIdx >= 0) pdpGallery.__sscGoTo(targetIdx);
      }

      const url = new URL(window.location.href);
      url.searchParams.set('variant', String(variant.id));
      window.history.replaceState({}, '', url.toString());
    }

    function updateVariantId() {
      const selectedOptions = getSelectedOptions();
      const matched = variants.find(variant =>
        Array.isArray(variant.options) &&
        variant.options.every((value, idx) => value === selectedOptions[idx])
      );
      if (matched) {
        syncVariantUi(matched);
      }
    }

    optionGroups.forEach(group => {
      const buttons = group.querySelectorAll('button[data-value]');
      buttons.forEach(button => {
        button.addEventListener('click', () => {
          setGroupSelection(group, button);
          updateVariantId();
        });
      });
    });

    const initialId = form.getAttribute('data-initial-variant-id');
    const initialVariant = variants.find(v => String(v.id) === String(initialId));
    if (initialVariant && Array.isArray(initialVariant.options)) {
      optionGroups.forEach((group, idx) => {
        const wanted = initialVariant.options[idx];
        const wantedButton = Array.from(group.querySelectorAll('button[data-value]')).find(
          btn => btn.getAttribute('data-value') === wanted
        );
        if (wantedButton) setGroupSelection(group, wantedButton);
      });
      variantInput.value = String(initialVariant.id);
    } else {
      updateVariantId();
    }
  });

  /* ── COLLECTION: SORT ── */
  document.querySelectorAll('.ssc-col-sort__select').forEach(select => {
    select.addEventListener('change', function () {
      const url = new URL(window.location.href);
      const val = this.value;
      if (val && val !== 'manual') {
        url.searchParams.set('sort_by', val);
      } else {
        url.searchParams.delete('sort_by');
      }
      window.location.href = url.toString();
    });
  });

  /* ── COLLECTION: FILTER DRAWER ── */
  const filterDrawer = document.getElementById('ssc-col-filters');
  const filterBackdrop = document.getElementById('ssc-col-filters-backdrop');
  function openFilters() {
    if (!filterDrawer || !filterBackdrop) return;
    filterDrawer.removeAttribute('hidden');
    filterBackdrop.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
  }
  function closeFilters() {
    if (!filterDrawer || !filterBackdrop) return;
    filterDrawer.setAttribute('hidden', '');
    filterBackdrop.setAttribute('hidden', '');
    document.body.style.overflow = '';
  }
  document.querySelectorAll('[data-action="open-filters"]').forEach(btn => {
    btn.addEventListener('click', openFilters);
  });
  document.querySelectorAll('[data-action="close-filters"]').forEach(btn => {
    btn.addEventListener('click', closeFilters);
  });
  if (filterBackdrop) filterBackdrop.addEventListener('click', closeFilters);

  /* ── COLLECTION: hydrate grid + load more ── */
  function formatGridPrice(amount, currency) {
    const value = parseFloat(amount);
    if (Number.isNaN(value)) return amount;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'fr', {
        style: 'currency',
        currency: currency || 'CHF',
      }).format(value);
    } catch (e) {
      return value.toFixed(2) + ' ' + (currency || '');
    }
  }

  function buildProductCard(product, gridRoot) {
    const currency = gridRoot.dataset.currency || 'CHF';
    const domain = gridRoot.dataset.shopDomain || window.location.hostname;
    const variant = product.variants && product.variants[0];
    const imageSrc =
      (product.images && product.images[0] && product.images[0].src) ||
      product.featured_image ||
      '';
    const price = variant ? variant.price : '';
    const compareAt = variant ? variant.compare_at_price : null;
    const onSale = compareAt && parseFloat(compareAt) > parseFloat(price);
    const productUrl = '/products/' + product.handle;
    const fullUrl = 'https://' + domain + productUrl;

    const card = document.createElement('div');
    card.className = 'ssc-product-card';
    card.dataset.productHandle = product.handle;

    let priceHtml = '<span>' + formatGridPrice(price, currency) + '</span>';
    if (onSale) {
      priceHtml =
        '<span class="ssc-product-card__price--compare">' +
        formatGridPrice(compareAt, currency) +
        '</span><span class="ssc-product-card__price--sale">' +
        formatGridPrice(price, currency) +
        '</span>';
    }

    const available = variant ? variant.available : true;
    const badgeHtml = available
      ? ''
      : '<span class="ssc-product-card__badge">Épuisé</span>';

    card.innerHTML =
      '<div class="ssc-product-card__media">' +
      '<a href="' +
      productUrl +
      '" class="ssc-product-card__img-link" aria-label="' +
      product.title.replace(/"/g, '&quot;') +
      '">' +
      (imageSrc
        ? '<img src="' +
          imageSrc +
          '" alt="' +
          product.title.replace(/"/g, '&quot;') +
          '" loading="lazy" width="100%" height="100%">'
        : '') +
      '</a>' +
      '<div class="ssc-product-card__wish" aria-label="Ajouter ' +
      product.title.replace(/"/g, '&quot;') +
      ' aux favoris">' +
      '<div data-wlh-id="' +
      product.id +
      '" data-wlh-link="' +
      fullUrl +
      '" data-wlh-variantid="' +
      (variant ? variant.id : '') +
      '" data-wlh-price="' +
      price +
      '" data-wlh-name="' +
      product.title.replace(/"/g, '&quot;') +
      '" data-wlh-image="' +
      imageSrc +
      '" class="wishlist-hero-custom-button ssc-wlh-grid" data-wlh-mode="icon_only" data-wlh-view="Collection" style="left: auto;"></div>' +
      '</div>' +
      badgeHtml +
      '</div>' +
      '<a href="' +
      productUrl +
      '" class="ssc-product-card__meta-link">' +
      '<p class="ssc-product-card__title">' +
      product.title +
      '</p>' +
      '<p class="ssc-product-card__price">' +
      priceHtml +
      '</p>' +
      '</a>';

    return card;
  }

  async function hydrateCollectionGrid(gridRoot) {
    const handle = gridRoot.dataset.collectionHandle;
    const total = parseInt(gridRoot.dataset.productsTotal, 10);
    const loaded = parseInt(gridRoot.dataset.productsLoaded, 10);
    if (!handle || !total || loaded >= total) return;

    const grid = gridRoot.querySelector('.ssc-pgrid__grid');
    if (!grid) return;

    const existingHandles = new Set(
      Array.from(grid.querySelectorAll('.ssc-product-card')).map(function (c) {
        return c.dataset.productHandle;
      })
    );

    const allProducts = [];
    let page = 1;

    while (allProducts.length < total) {
      const res = await fetch(
        '/collections/' + encodeURIComponent(handle) + '/products.json?limit=250&page=' + page
      );
      if (!res.ok) break;
      const data = await res.json();
      if (!data.products || !data.products.length) break;
      allProducts.push.apply(allProducts, data.products);
      if (data.products.length < 250) break;
      page += 1;
    }

    allProducts.forEach(function (product) {
      if (!product.handle || existingHandles.has(product.handle)) return;
      grid.appendChild(buildProductCard(product, gridRoot));
      existingHandles.add(product.handle);
    });

    gridRoot.dataset.productsLoaded = String(existingHandles.size);
    initSscWishlistHeroButtons();
  }

  function initGridLoadMore(gridRoot, step) {
    const btn = gridRoot.querySelector('[data-ssc-load-more]');
    const loadMoreWrap = btn ? btn.closest('.ssc-pgrid__loadmore') : null;
    const STEP = step || 6;
    let visible = STEP;

    function refreshCards() {
      return Array.from(gridRoot.querySelectorAll('.ssc-product-card'));
    }

    let cards = refreshCards();
    if (!cards.length) {
      loadMoreWrap?.setAttribute('hidden', '');
      return;
    }

    if (!btn) {
      cards.forEach(function (card) {
        card.style.display = '';
      });
      return;
    }

    cards.forEach(function (card, idx) {
      card.style.display = idx < visible ? '' : 'none';
    });

    if (cards.length <= STEP) {
      loadMoreWrap?.setAttribute('hidden', '');
      return;
    }

    loadMoreWrap?.removeAttribute('hidden');

    if (btn.dataset.sscLoadMoreBound === 'true') return;
    btn.dataset.sscLoadMoreBound = 'true';

    btn.addEventListener('click', function () {
      cards = refreshCards();
      const nextVisible = visible + STEP;
      cards.forEach(function (card, idx) {
        card.style.display = idx < nextVisible ? '' : 'none';
      });
      visible = nextVisible;
      if (visible >= cards.length) {
        loadMoreWrap?.setAttribute('hidden', '');
      }
      initSscWishlistHeroButtons();
    });
  }

  /* ── DESKTOP COLLECTION: hydrate + load more (12) ── */
  var SSC_COLLECTION_EXCLUDED = ['la-marque', 'nos-engagements', 'le-journal'];

  function getCollectionHandleFromPath() {
    var match = window.location.pathname.match(/\/collections\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function getGridProductHandles(grid) {
    var handles = new Set();
    grid.querySelectorAll('a[href*="/products/"]').forEach(function (link) {
      var hrefMatch = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
      if (hrefMatch) handles.add(hrefMatch[1]);
    });
    return handles;
  }

  async function fetchAllCollectionProducts(handle) {
    var allProducts = [];
    var page = 1;

    while (true) {
      var res = await fetch(
        '/collections/' + encodeURIComponent(handle) + '/products.json?limit=250&page=' + page
      );
      if (!res.ok) break;
      var data = await res.json();
      if (!data.products || !data.products.length) break;
      allProducts = allProducts.concat(data.products);
      if (data.products.length < 250) break;
      page += 1;
    }

    return allProducts;
  }

  async function fetchDesktopProductItems(handle, sectionId, page) {
    var url =
      '/collections/' +
      encodeURIComponent(handle) +
      '?page=' +
      page +
      '&sections=' +
      encodeURIComponent(sectionId);
    var res = await fetch(url);
    if (!res.ok) return [];

    var data = await res.json();
    var html = data[sectionId];
    if (!html) return [];

    var doc = new DOMParser().parseFromString(html, 'text/html');
    return Array.from(doc.querySelectorAll('ul.product-grid .product-grid__item'));
  }

  function isLoadMoreLabel(el) {
    return /en\s*voir\s*plus/i.test((el.textContent || '').replace(/\s+/g, ' ').trim());
  }

  function findDesktopLoadMoreButton() {
    var main = document.querySelector('#MainContent[data-template*="collection"]');
    if (!main) return null;

    var candidates = main.querySelectorAll('a, button');
    for (var i = 0; i < candidates.length; i++) {
      if (isLoadMoreLabel(candidates[i])) return candidates[i];
    }
    return null;
  }

  function getDesktopGridConfig() {
    var handle = getCollectionHandleFromPath();
    if (handle === 'femme') {
      return { initial: 11, step: 12 };
    }
    return { initial: 12, step: 12 };
  }

  function applyDesktopGridVisibility(grid) {
    var config = getDesktopGridConfig();
    var visible = parseInt(grid.dataset.sscDesktopVisible, 10) || config.initial;
    var items = grid.querySelectorAll('.product-grid__item');
    items.forEach(function (item, idx) {
      item.style.display = idx < visible ? '' : 'none';
    });
    return items.length;
  }

  function updateDesktopLoadMoreButton(grid) {
    var btn = findDesktopLoadMoreButton();
    var btnSection = btn ? btn.closest('.shopify-section') : null;
    var config = getDesktopGridConfig();
    var step = parseInt(grid.dataset.sscDesktopStep, 10) || config.step;
    var total = grid.querySelectorAll('.product-grid__item').length;
    var visible = parseInt(grid.dataset.sscDesktopVisible, 10) || config.initial;
    var done = visible >= total;

    if (btn) {
      btn.removeAttribute('aria-disabled');
      btn.removeAttribute('disabled');
      btn.setAttribute('data-ssc-desktop-load-more', 'true');
      btn.style.cursor = 'pointer';
      btn.style.opacity = '1';
      btn.style.pointerEvents = 'auto';

      if (btn.tagName === 'A') {
        btn.setAttribute('href', 'javascript:void(0)');
        btn.setAttribute('role', 'button');
        btn.setAttribute('aria-label', 'Afficher plus de produits');
      }
    }

    if (!btnSection) return;

    if (done) {
      btnSection.style.display = 'none';
      btnSection.setAttribute('hidden', '');
    } else {
      btnSection.style.display = '';
      btnSection.removeAttribute('hidden');
    }
  }

  function setupDesktopCollectionGrid(grid) {
    var config = getDesktopGridConfig();
    grid.dataset.sscDesktopLoadMoreReady = 'true';
    grid.dataset.sscDesktopStep = String(config.step);
    grid.dataset.sscDesktopVisible = String(config.initial);
    applyDesktopGridVisibility(grid);
    updateDesktopLoadMoreButton(grid);
  }

  function handleDesktopLoadMoreClick(event) {
    if (!window.matchMedia('(min-width: 990px)').matches) return;

    var main = document.getElementById('MainContent');
    if (!main || !main.dataset.template || main.dataset.template.indexOf('collection') === -1) return;

    var target = event.target.closest('a, button');
    if (!target || !isLoadMoreLabel(target)) return;

    var grid = main.querySelector('ul.product-grid');
    if (!grid || grid.dataset.sscDesktopLoadMoreReady !== 'true') return;

    event.preventDefault();
    event.stopImmediatePropagation();

    var step = parseInt(grid.dataset.sscDesktopStep, 10) || 12;
    var visible = parseInt(grid.dataset.sscDesktopVisible, 10) || step;
    grid.dataset.sscDesktopVisible = String(visible + step);
    applyDesktopGridVisibility(grid);
    updateDesktopLoadMoreButton(grid);
  }

  if (!window.__sscDesktopLoadMoreBound) {
    window.__sscDesktopLoadMoreBound = true;
    document.addEventListener('click', handleDesktopLoadMoreClick, true);
  }

  async function hydrateDesktopCollectionGrid() {
    if (!window.matchMedia('(min-width: 990px)').matches) return;

    var handle = getCollectionHandleFromPath();
    if (!handle || SSC_COLLECTION_EXCLUDED.indexOf(handle) !== -1) return;

    var grid = document.querySelector('#MainContent[data-template*="collection"] ul.product-grid');
    if (!grid) return;

    setupDesktopCollectionGrid(grid);

    var section = grid.closest('.shopify-section');
    var sectionId = section && section.id ? section.id.replace('shopify-section-', '') : '';
    if (!sectionId) {
      return;
    }

    var existingHandles = getGridProductHandles(grid);
    var allProducts = await fetchAllCollectionProducts(handle);
    var total = allProducts.length;
    var maxPages = parseInt(grid.dataset.lastPage, 10) || 1;
    var page = 2;

    while (existingHandles.size < total && page <= maxPages) {
      var newItems = await fetchDesktopProductItems(handle, sectionId, page);
      if (!newItems.length) break;

      newItems.forEach(function (item) {
        var link = item.querySelector('a[href*="/products/"]');
        var hrefMatch = link && link.getAttribute('href').match(/\/products\/([^/?#]+)/);
        if (!hrefMatch || existingHandles.has(hrefMatch[1])) return;
        grid.appendChild(item);
        existingHandles.add(hrefMatch[1]);
      });

      page += 1;
    }

    applyDesktopGridVisibility(grid);
    updateDesktopLoadMoreButton(grid);
  }

  if (window.matchMedia('(max-width: 989px)').matches) {
    document.querySelectorAll('.ssc-pgrid').forEach(function (gridRoot) {
      hydrateCollectionGrid(gridRoot).then(function () {
        initGridLoadMore(gridRoot, 6);
      });
    });
  }

  if (window.matchMedia('(min-width: 990px)').matches) {
    hydrateDesktopCollectionGrid();
  }

  document.addEventListener('shopify:section:load', function () {
    if (window.matchMedia('(max-width: 989px)').matches) {
      document.querySelectorAll('.ssc-pgrid').forEach(function (gridRoot) {
        hydrateCollectionGrid(gridRoot).then(function () {
          initGridLoadMore(gridRoot, 6);
        });
      });
    }
    if (window.matchMedia('(min-width: 990px)').matches) {
      hydrateDesktopCollectionGrid();
    }
  });
})();